import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Row, Col } from 'pui-react-grids'
import ChangePasswordForm from '../common/ChangePasswordForm'
import Footer from '../common/Footer'
import { handleSumbissionErrors } from '../form/errors'
import { makeAuthenticatedApi } from '../api'

const styles = {
  mainCol: {
    margin: 0,
    paddingBottom: '40px',
  },
}

class ChangePassword extends PureComponent {
  handleUpdatePassword = data => {
    return this.props.api
      .updatePassword(data.current_password, data.password)
      .catch(handleSumbissionErrors)
  }

  handleUpdatePasswordSuccess = newUserData => {
    this.props.history.replace('/profile')
  }

  render() {
    return (
      <div>
        <div className="padding">
          <Row style={{ marginLeft: 0, marginRight: 0 }}>
            <Col md={3} />
            <Col md={18} style={styles.mainCol}>
              <ChangePasswordForm
                onSubmit={this.handleUpdatePassword}
                onSubmitSuccess={this.handleUpdatePasswordSuccess}
              />
            </Col>
            <Col md={3} />
          </Row>
        </div>
        <Row style={{ marginTop: 70 }}>
          <Footer />
        </Row>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  api: makeAuthenticatedApi(state),
})

export default connect(mapStateToProps)(ChangePassword)



// WEBPACK FOOTER //
// ./src/pages/ChangePassword.js